import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col, Portlet } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { DownloadAxiosFile } from 'utils'

import * as FormGroups from './formGroups'

import { MonedasConstant } from 'constants/index'

import * as AsientoContableService from 'services/asientosContables.service'

const ReporteLibroAuxiliar = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [cuentaContableSeleccionada, setCuentaContableSeleccionada] = React.useState('')
  const [cuentaContableInfo, setCuentaContableInfo] = React.useState('')
  const [periodoHasta, setPeriodoHasta] = React.useState(__adminContext.mesTrabajo)
  const [flagTodos, setFlagTodos] = React.useState(false)
  const [idSocioSeleccionado, setIdSocioSeleccionado] = React.useState('')
  const [documentoSocioSeleccionado, setDocumentoSocioSeleccionado] = React.useState('')
  const [nombreSocioSeleccionado, setNombreSocioSeleccionado] = React.useState('')
  const [moneda, setMoneda] = React.useState(MonedasConstant.__array[0].nombre)

  const descargarReporteLibrosAuxiliar = React.useCallback(() => {
    if (!cuentaContableSeleccionada) {
      __zariContext.snack('error', 'El campo cuenta es requerido')
    } else if (!flagTodos && !idSocioSeleccionado) {
      __zariContext.snack('error', 'El campo cliente/proveedor es requerido')
    } else {
      __zariContext.loader.open('Descargando libro Auxiliar...')
      AsientoContableService.descargarReporteLibroAuxiliar({
        cuentaContableSeleccionada,
        periodoHasta,
        flagTodos,
        idSocioSeleccionado,
        moneda
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    }
  }, [__zariContext, cuentaContableSeleccionada, periodoHasta, flagTodos, idSocioSeleccionado, moneda])

  return (
    <>
      <Row className='zari-slim-form'>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Libro Auxiliar' />
            <Portlet.Body>
              <Row>
                <Col md={12}>
                  <FormGroups.CuentaFormGroup
                    setCuentaContableSeleccionada={setCuentaContableSeleccionada}
                    cuentaContableSeleccionada={cuentaContableSeleccionada}
                    setCuentaInfo={setCuentaContableInfo}
                    cuentaContableInfo={cuentaContableInfo}
                  />
                  <FormGroups.MesFormGroup texto='HASTA' periodo={periodoHasta} setPeriodo={e => setPeriodoHasta(e.target.value)} />
                  <Row>
                    <Col md={2} />
                    <Col md={10}>
                      <Form.Group>
                        <Col md={8}>
                          <Form.Checkbox
                            id='checkbox-flagTodos'
                            name='flagTodos'
                            label='Todos los RUC / DNI'
                            checked={flagTodos}
                            onChange={() => {
                              setFlagTodos(prev => !prev)
                              setIdSocioSeleccionado('')
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  {!flagTodos && (
                    <FormGroups.SocioTodosFormGroup
                      idSocioSeleccionado={idSocioSeleccionado}
                      setIdSocioSeleccionado={setIdSocioSeleccionado}
                      documentoSocioSeleccionado={documentoSocioSeleccionado}
                      setDocumentoSocioSeleccionado={setDocumentoSocioSeleccionado}
                      nombreSocioSeleccionado={nombreSocioSeleccionado}
                      setNombreSocioSeleccionado={setNombreSocioSeleccionado}
                    />
                  )}

                  <FormGroups.MonedaFormGroup moneda={moneda} setMoneda={e => setMoneda(e.target.value)} />

                  <Row>
                    <Col md={12} className='text-right'>
                      <Button onClick={descargarReporteLibrosAuxiliar}>Descargar</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ReporteLibroAuxiliar)
